module.exports = __webpack_public_path__ + "img/cross.f51ce199.svg";